import { NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const navItems = [
  { to: "/", label: "Agenda", testId: "nav-agenda-link" },
  { to: "/customers", label: "Clienti", testId: "nav-customers-link" },
  { to: "/services", label: "Servizi", testId: "nav-services-link" },
  { to: "/staff", label: "Staff", testId: "nav-staff-link", ownerOnly: true },
  { to: "/recovery", label: "Recupero Slot", testId: "nav-recovery-link", ownerOnly: true },
  { to: "/business-profile", label: "Profilo attività", testId: "nav-business-profile-link", ownerOnly: true },
  { to: "/business-hours", label: "Orari", testId: "nav-business-hours-link", ownerOnly: true },
  { to: "/owner-alerts", label: "Avvisi", testId: "nav-owner-alerts-link", ownerOnly: true },
  { to: "/trash", label: "Cestino", testId: "nav-trash-link", ownerOnly: true },
  { to: "/activity", label: "Registro attività", testId: "nav-activity-link", ownerOnly: true },
];

function getUnreadBadgeLabel(ownerAlertsUnreadCount) {
  if (ownerAlertsUnreadCount > 99) {
    return "99+";
  }

  return String(ownerAlertsUnreadCount);
}

export function Sidebar({ ownerAlertsUnreadCount = 0 }) {
  const { isOwner } = useAuth();
  const visibleNavItems = navItems.filter((item) => !item.ownerOnly || isOwner);

  return (
    <aside
      className="w-64 min-h-screen bg-slate-100 border-r border-slate-200 px-6 py-8"
      data-testid="sidebar-container"
    >
      <div className="mb-10">
        <div
          className="text-xl font-bold section-title"
          data-testid="sidebar-brand"
        >
          FullBook
        </div>
        <p className="text-xs uppercase tracking-[0.2em] text-slate-500 mt-1" data-testid="sidebar-subtitle">
          Agenda orientata ai ricavi
        </p>
      </div>
      <nav className="space-y-2" data-testid="sidebar-nav">
        {visibleNavItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            data-testid={item.testId}
            className={({ isActive }) =>
              `block rounded-sm px-3 py-2 text-sm font-medium transition-colors ${
                isActive
                  ? "bg-slate-900 text-white"
                  : "text-slate-600 hover:text-slate-900 hover:bg-slate-200"
              }`
            }
          >
            <span className="flex items-center justify-between gap-3">
              <span>{item.label}</span>
              {item.to === "/owner-alerts" && ownerAlertsUnreadCount > 0 && (
                <span
                  className="min-w-6 rounded-sm bg-slate-200 px-2 py-0.5 text-xs font-semibold text-slate-700"
                  data-testid="nav-owner-alerts-badge"
                >
                  {getUnreadBadgeLabel(ownerAlertsUnreadCount)}
                </span>
              )}
            </span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
